import axios from 'axios';
import { getHeadersWithToken } from './apiUitility';
import { environment } from '../../environments/environment';
import { clearStoredAuthTokens } from '../utils/auth';

// Add global interceptors to base axios object to cover components using raw axios
axios.interceptors.request.use(
  (config) => {
    const headers = getHeadersWithToken();
    config.headers = { ...config.headers, ...headers };
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const errorData = error.response.data;
      if (errorData && errorData.error === "jwt expired") {
        clearStoredAuthTokens();
        window.location.href = '/#/login?sessionExpired=true';
      }
    }
    return Promise.reject(error);
  }
);

const axiosInstance = axios.create({
  baseURL: `${environment.controlplaneUrl}/manage`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const headers = getHeadersWithToken(); // Use the headers module
    config.headers = { ...config.headers, ...headers }; // Merge headers
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// We keep the instance interceptor as well because instances don't inherit global interceptors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const errorData = error.response.data;
      if (errorData && errorData.error === "jwt expired") {
        clearStoredAuthTokens();
        window.location.href = '/#/login?sessionExpired=true';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
